module.exports = __webpack_public_path__ + "img/GlobeChek_EYE.1966624d.png";